// Product gallery with thumbnails: each thumbnail button shows its slide.
class VoltoyGallery extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.onClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.onClick);
  }

  onClick = (event) => {
    const thumb = event.target.closest('[data-gallery-thumb]');
    if (!thumb || !this.contains(thumb)) return;
    const index = thumb.dataset.galleryThumb;
    this.querySelectorAll('[data-gallery-slide]').forEach((slide) => {
      slide.hidden = slide.dataset.gallerySlide !== index;
    });
    this.querySelectorAll('[data-gallery-thumb]').forEach((button) => {
      button.setAttribute('aria-current', String(button === thumb));
    });
  };
}

if (!customElements.get('voltoy-gallery')) {
  customElements.define('voltoy-gallery', VoltoyGallery);
}
